(function (angular) {
    'use strict';

    angular.module('reports')

        .component('teamAgentSummary', {
            bindings: {
            },
            controller: ["liveChatService", function (liveChatService) {
                var ctrl = this;

                ctrl.agentStats = [];

                /**
                 * 
                 */
                ctrl.updateData = function (data) {
                    if (!angular.equals(ctrl.agentStats, data.team)) {
                        ctrl.agentStats = data.team;
                    }
                }

                var listenerFunc = ctrl.updateData.bind(this);

                /**
                 * 
                 */
                ctrl.$onInit = function () {
                    liveChatService.addEventListener(listenerFunc);
                }

                /**
                 * 
                 */
                ctrl.$onDestroy = function () {
                    liveChatService.removeEventListener(listenerFunc);
                }

            }],
            templateUrl: 'components/reports/chat/templates/teamAgentSummaryComponent.html'
        })

})(window.angular);